export default "__VITE_ASSET__DCjHabz8__"